/* Система налогообложения */

export default class SnoType {
  /* Общая СН. */
  static get OSN () { return 'osn' }

  /* Упрощенная СН (доходы). */
  static get USN_INCOME () { return 'usn_income' }

  /* Упрощенная СН (доходы минус расходы). */
  static get USN_INCOME_OUTCOME () { return 'usn_income_outcome' }

  /* Единый налог на вмененный доход. */
  static get ENVD () { return 'envd' }

  /* Единый сельскохозяйственный налог. */
  static get ESN () { return 'esn' }

  /* Патентная СН. */
  static get PATENT () { return 'patent' }

  static getName (enumValue) {
    switch (enumValue) {
      case SnoType.OSN:
        return 'Общая СН'

      case SnoType.USN_INCOME:
        return 'Упрощенная СН (доходы)'

      case SnoType.USN_INCOME_OUTCOME:
        return 'Упрощенная СН (доходы минус расходы)'

      case SnoType.ENVD:
        return 'Единый налог на вмененный доход'

      case SnoType.ESN:
        return 'Единый сельскохозяйственный налог'

      case SnoType.PATENT:
        return 'Патентная СН'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      SnoType.USN_INCOME,
      SnoType.USN_INCOME_OUTCOME,
      SnoType.ENVD,
      SnoType.ESN,
      SnoType.PATENT,
    ]

    return variants.map(item => ({
      value: item,
      name: SnoType.getName(item),
    }))
  }
}
